<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setQuickToken, removeQuickToken } from '@/utils/auth'
import { AppUtils, Bridge } from '@/utils/bridge';
import store from './store';

export default {
  name: 'App',
  data(){
    return{
      isRouterAlive:true
    }
  },
  created() {
    // if(Bridge.isInNative()){
    //   AppUtils.getUserInfo(data => {
    //     // console.log(data.userId)
    //   })
    // }
  },
  methods: {
  }
}
</script>

<style lang="scss">
/*每个页面公共css */
@import './assets/css/reset.scss';
@import './assets/css/iconfont/iconfont.css';
@import './assets/css/quill/quillSnow.css';
@import './assets/css/quill/quillCore.css';
@import './assets/css/quill/quillBubble.css';

.wrapper{
  width: 100%;
  position: relative;
}
.disable-btn{
  opacity: 0.4;
}
.wraper{
  width: 375px;
  height: 668px;
  margin: 0 auto;
  border-radius: 8px;
  background: #fff;
  position: relative;
}
@media screen and (max-width:750px){
  .container {
    width: 18.75rem;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fff;
  }
  .footer-bar{
    width: 18.75rem;
    height: 4.5rem;
    margin: 0 auto;
    display: block;
  }
  .footer{
    width: 18.75rem;
    height: 2.2rem;
    margin: 0 auto;
    padding: .6rem 0 1.6rem;
    background: #fff;
    @include p-row-center(fixed,99);
    position: fixed;
    bottom: 0;
    z-index: 99;
    //box-shadow: 0px -5px 5px #eee;
    .submit-btn{
      width: 15rem;
      height: 2.2rem;
      margin: 0 auto;
      background: $base-color;
      border-radius: .4rem;
      font-size: .8rem;
      color: #fff;
      text-align: center;
      cursor: pointer;
      @include flex();
    }
    .disabled-btn{
      opacity: 0.6;
    }
    .btn-group{
      width: 14.2rem;
      margin: 0 auto;
      @include flex(space-between);
      .btn{
        width: 6.5rem;
        height: 2.2rem;
        border-radius: .5rem;
        font-size: .8rem;
        font-weight: 600;
        cursor: pointer;
        @include flex();
      }
      .prev-btn{
        border: .05rem solid #EEEEEE;
        background: #fff;
        color: #222;
      }
      .confim-btn{
        margin-left: 1.2rem;
        border: .05rem solid $base-color;
        color: #FFFFFF;
        background: $base-color;
        font-family: "PingFangSC-Semibold, PingFang SC";
      }
    }
  }
}
@media screen and (min-width:750px){
  html{
    background: #F5F5F7;
  }
  .container{
    width: 375px;
    height: 668px;
    overflow-y: scroll;
    margin: 50px auto 0;
    //box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.05);
    border-radius: 8px;
    background: #fff;
    box-sizing: border-box;
    padding-top: 1px;
    position: relative;
  }
  .container::-webkit-scrollbar { width: 0 !important }
  .wrapper{
    width: 375px;
    height: 668px;
    margin: 0 auto;
    border-radius: 8px;
    background: #fff;
    margin-top: 50px;
    .container{
      //height: 574px;
      height: 529px;
      padding-top: 1px;
      border-radius: 8px 8px 0 0;
      margin-top: 0;
    }
  }
  .footer-bar{
    width: 375px;
    height: 94px;
    margin: 0 auto;
    display: none;
  }
  .footer{
    width: 375px;
    height: 94px;
    margin: 0 auto;
    padding: 20px 0 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0 0 8px 8px;
    @include p-row-center(absolute,2003);
    bottom: 0;
    // position: absolute;
    // bottom: 24px;
    // z-index: 2003;
    .submit-btn{
      width: 300px;
      height: 44px;
      margin: 0 auto;
      background: $base-color;
      border-radius: 8px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      @include flex();
    }
    .disabled-btn{
      opacity: 0.6;
    }
    .btn-group{
      width: 284px;
      margin: 0 auto;
      @include flex(space-between);
      .btn{
        width: 130px;
        height: 44px;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        @include flex();
      }
      .prev-btn{
        border: 1px solid #EEEEEE;
        background: #fff;
        color: #222;
      }
      .confim-btn{
        margin-left: 24px;
        border: 1px solid $base-color;
        color: #FFFFFF;
        background: $base-color;
        font-family: "PingFangSC-Semibold, PingFang SC";
      }
    }
  }
}
body{
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue